// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"_ae0641","icon":"_c7c875","link":"_bd2b31"};